var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmarkIconThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.08714 10.4652L4.01611 8.25765C3.78335 8.00954 3.40734 8.00954 3.17457 8.25765C2.94181 8.50576 2.94181 8.90656 3.17457 9.15467L5.66935 11.8139C5.90212 12.062 6.27813 12.062 6.51089 11.8139L12.8254 5.0831C13.0582 4.83499 13.0582 4.43419 12.8254 4.18608C12.5927 3.93797 12.2167 3.93797 11.9839 4.18608L9.03551 7.32565L6.08714 10.4652Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkIconThin);
export default __webpack_public_path__ + "static/media/checkmark-icon-thin.e3db8d33.svg";
export { ForwardRef as ReactComponent };